import React from "react";
import { useTranslation } from "react-i18next";
import FooterSection from "../../../components/sections/FooterSection";
import ParallaxCallSection from "../../../components/sections/ParallaxCallSection";

/**
 * This is an article page about how foreigners can obtain A5 visa in kazakhstan
 * @returns 
 */
function A5VisaPage() {

  var { t } = useTranslation();

  return (
    <>
      <ParallaxCallSection
        isTopElement={true}
        URL="/imgvideo/astana_hd.jpg"
        headline="Unlock Your Future in Kazakhstan: A Land of Opportunity for Investors"
        callToAction="Discover Your Path to Success"
      />

      <div className="uk-container uk-margin-large-top uk-margin-large-bottom">
        <div className="uk-section uk-section-default uk-padding">
          <div className="uk-container">
            <h1 className="uk-heading-medium uk-text-bold uk-text-center">
              Why Kazakhstan? The Gateway to Eurasia for African Entrepreneurs
            </h1>
            <p className="uk-text-lead uk-text-center">
              Kazakhstan is a rapidly growing economy at the heart of Eurasia,
              offering a stable and welcoming environment for international
              business. For African investors and entrepreneurs, it represents a
              strategic gateway to the vast markets of Europe and Asia. At Jai
              International, we specialize in helping you navigate this
              promising landscape.
            </p>
          </div>
        </div>

        <div className="uk-section uk-section-muted uk-padding">
          <h2 className="uk-heading-bullet uk-text-center uk-margin-medium-bottom">
            Key Advantages for Investors
          </h2>
          <div
            className="uk-grid-match uk-child-width-1-3@m uk-grid-medium"
            data-uk-grid
          >
            <div>
              <div className="uk-card uk-card-default uk-card-body uk-card-hover">
                <h3 className="uk-card-title">Strategic Location</h3>
                <p>
                  Positioned between China, Russia, and Europe, Kazakhstan is a
                  critical hub for trade and logistics, offering unparalleled
                  access to over a billion consumers.
                </p>
              </div>
            </div>
            <div>
              <div className="uk-card uk-card-jai uk-card-body uk-card-hover">
                <h3 className="uk-card-title">Supportive Government</h3>
                <p>
                  Benefit from tax exemptions, special economic zones (SEZ), and
                  the AIFC's English common law jurisdiction, designed to
                  protect and encourage foreign investment.
                </p>
              </div>
            </div>
            <div>
              <div className="uk-card uk-card-default uk-card-body uk-card-hover">
                <h3 className="uk-card-title">Resource-Rich Economy</h3>
                <p>
                  Explore opportunities in sectors like agriculture, mining,
                  technology, and renewable energy, backed by the nation's vast
                  natural resources.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="uk-section uk-section-default uk-padding">
          <h2 className="uk-heading-line uk-text-center">
            <span>The A5 Investor Visa: Your Key to Long-Term Presence</span>
          </h2>
          <p>
            The A5 Investor Visa is designed for foreign nationals who are
            founders or participants of companies registered in Kazakhstan. It
            provides a clear pathway for entrepreneurs to establish and manage
            their business operations within the country.
          </p>
          <ul className="uk-list uk-list-bullet">
            <li>
              <strong>Long-Term Residency:</strong> The A5 visa allows for an
              extended stay, with the possibility of renewal, enabling you to
              oversee your investment's growth.
            </li>
            <li>
              <strong>Business Operations:</strong> It grants you the right to
              actively engage in your company's management and strategic
              development.
            </li>
            <li>
              <strong>Family Inclusion:</strong> The visa can be extended to
              include family members, allowing them to reside with you in
              Kazakhstan.
            </li>
          </ul>
        </div>


      </div>
      <div className="uk-section uk-section-primary uk-light uk-padding uk-text-center">
        <h2 className="uk-heading-medium">
          Let Jai International Be Your Guide
        </h2>
        <p className="uk-text-lead">
          From visa applications to company registration and investment
          consulting, our expert team provides end-to-end support to ensure
          your journey into the Kazakh market is smooth and successful.
        </p>
        <a href="/apply-visa" className="uk-button uk-button-large uk-button-jai uk-margin-top">
          Start Your Investment Journey Today
        </a>
      </div>
      <FooterSection />
    </>
  );
}

export default A5VisaPage;